export const allowedFileExtensions = ['.jpg', '.jpeg', '.png', '.bmp', '.doc', '.docx', '.pdf', '.xls', '.xlsx'];

export const fileMaxSize = 20971520;
